import type { FC } from 'react';
import React from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

const NEUTRAL_100 = 'neutral.100';

const ItineraryCover: FC = () => {
  const { t } = useTranslation();

  return (
    <ul>
      <li>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.cover.not.provided.item1')}
        </Body>
      </li>
      <li>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.cover.not.provided.item2')}
        </Body>
      </li>
      <li>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.cover.not.provided.item3')}
        </Body>
      </li>
      <li>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.cover.not.provided.item4')}
        </Body>
      </li>
    </ul>
  );
};

const InsuranceModalContentMapItinerary: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.missed.connection.description')}
        </Body>
      </div>
      <br></br>
      <div>
        <Body type="small" color={NEUTRAL_100} weight="medium">
          {t('flightSummary.itinerary.cover.provided.title')}
        </Body>
      </div>
      <div>
        <ItineraryCover />
      </div>
      <br></br>
      <div>
        <Body type="small" color={NEUTRAL_100}>
          {t('flightSummary.itinerary.cover.provided.description')}
        </Body>
      </div>
      <div>
        <Body type="small" color={NEUTRAL_100} weight="medium">
          {t('flightSummary.itinerary.cover.not.provided.title')}
        </Body>
      </div>
      <div>
        <ItineraryCover />
      </div>
    </>
  );
};

export default InsuranceModalContentMapItinerary;
